import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { User } from '@/types/user';

type AuthState = {
  user: User | null;
  isAuthenticated: boolean;
  isLivenessChecked: boolean;

  // Actions
  setUser: (user: User | null) => void;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  setAuthState: (user: User | null, isAuthenticated: boolean) => void;
  setLivenessChecked: (isLivenessChecked: boolean) => void;
  clearUser: () => void;
};

export const useAuthStore = create<AuthState>()(
  devtools(
    (set) => ({
      // Initial state
      user: null,
      isAuthenticated: false,
      isLivenessChecked: false,

      // Actions
      setUser: (user) => set({ user }),
      setIsAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
      setAuthState: (user, isAuthenticated) =>
        set({
          user,
          isAuthenticated,
        }),
      setLivenessChecked: (isLivenessChecked) => set({ isLivenessChecked }),
      clearUser: () =>
        set({
          user: null,
          isAuthenticated: false,
          isLivenessChecked: false,
        }),
    }),
    { name: 'AuthStore' }
  )
);

// Selectors
export const useUser = () => useAuthStore((state) => state.user);
export const useIsAuthenticated = () => useAuthStore((state) => state.isAuthenticated);
